module.exports = __webpack_public_path__ + "img/link-invalid.a8f2ef7d.png";